// 倒计时模板,单页面引入
<template>
  <div class="hint">
    {{beforeText}}{{Time}}{{afterText}}
  </div>
</template>

<script>
let vm, interval = '', list = []


export default {
  name: 'countDown',
  props: {
    time: {
      type: Number,
      default: 120
    },
    // time前的文字
    beforeText: {
      type: String,
      default: ''
    },
    // time后的文字
    afterText: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      Time: this.time
    }
  },
  created () {
    vm = this
    // console.log('time', vm.time)
    vm.defalutCountDown()
  },
  mounted () {
    console.log('倒计时mounted', '')
  },
  destroyed () {
    console.log('倒计时destroyed', '')
    vm.clearCountDown()
  },
  methods: {
    countDown(func) {
      interval = window.setInterval(function () {
        func()
      }, 1000)
    },
    clearCountDown () {
      clearInterval(interval)
      interval = ''
    },
    // 默认倒计时
    defalutCountDown () {
      vm.countDown(function () {
        vm.Time--
        // console.log('vm.Time', vm.Time)
        // console.log(vm.Time < 0)
        if (vm.Time <= 0) {
          vm.clearCountDown()
          vm.cancelBack()
        }
      })
    },
    // 返回首页
    cancelBack: function () {
      // return
      vm.$store.state.type = ''
      vm.$store.state.eUserInfo = ''
      vm.$store.state.ECMall_activeGoods = {}
      vm.$store.state.ECMall_timeEnd = !(vm.$store.state.ECMall_timeEnd)
      vm.$router.push({
        // 你要跳转的地址
        path: '/Bookcase/Index'
      })
    }
  },
  watch: {
  }
}

</script>

<style  scoped>
.hint{
  opacity: 0;
  /* font-size: 0.6rem;
  line-height: 1em;
  color: #666;
  font-weight: bold;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999; */
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Common/CountDown.vue